import { useContext, useMemo } from 'react'
import EventsService, { AppFormEventParams, EventsServiceResult } from '../services/events-service'
import { ApplicationFormContext } from '../components/ApplicationForm/ApplicationFormContext'

export const useAppFormEventsService = (eventsServiceUrl?: string, appFormEventParams?: AppFormEventParams): EventsServiceResult | undefined => {
  const { eventsService: contextEventsService } = useContext(ApplicationFormContext)

  return useMemo(() => {
    if (eventsServiceUrl && appFormEventParams) {
      return EventsService(eventsServiceUrl, appFormEventParams)
    }

    return contextEventsService
  }, [eventsServiceUrl, appFormEventParams, contextEventsService])
}
